import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
export function Pricing() {
  const plans = [{
    name: 'Starter',
    price: '€2,900',
    period: '/month',
    description: 'For emerging sportsbook affiliates',
    features: ['5 target keywords', 'Monthly reporting', 'Basic link building', 'Compliance audit', 'Email support'],
    highlighted: false
  }, {
    name: 'Professional',
    price: '€5,400',
    period: '/month',
    description: 'For scaling affiliate operations',
    badge: 'MOST POPULAR',
    features: ['25 target keywords', 'Weekly reporting', 'Advanced link building', 'Full compliance management', 'Affiliate tracking setup', 'Priority support', 'Quarterly strategy calls'],
    highlighted: true
  }, {
    name: 'Enterprise',
    price: '€9,800',
    period: '/month',
    description: 'For established iGaming operators',
    features: ['Unlimited keywords', 'Daily reporting', 'Dedicated strategist', 'Custom dashboards', 'Multi-market expansion', 'White-label solutions', '24/7 support', 'Monthly executive reviews'],
    highlighted: false
  }];
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="pricing" className="py-20 bg-[#0a1a0f]" data-id="element-97">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-98">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-99">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4" data-id="element-100">
            Select Your <span className="text-[#00ff88]" data-id="element-101">Stake</span>
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-102">
            Transparent pricing for every stage of growth
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-103">
          {plans.map((plan, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`relative bg-[#0d2818] rounded-lg p-8 ${plan.highlighted ? 'border-2 border-[#d4a017] glow-gold' : 'border border-[#00ff88]/20'}`} data-id="element-104">
              {plan.badge && <div className="absolute -top-4 left-1/2 transform -translate-x-1/2" data-id="element-105">
                  <div className="bg-[#d4a017] text-[#0a1a0f] px-4 py-1 rounded-full text-xs font-bold flex items-center space-x-1" data-id="element-106">
                    <Star size={12} data-id="element-107" />
                    <span data-id="element-108">{plan.badge}</span>
                  </div>
                </div>}

              <div className="text-center mb-6" data-id="element-109">
                <h3 className="text-2xl font-bold mb-2" data-id="element-110">{plan.name}</h3>
                <p className="text-gray-400 text-sm mb-4" data-id="element-111">{plan.description}</p>
                <div className="flex items-baseline justify-center" data-id="element-112">
                  <span className="text-4xl font-bold font-mono text-[#00ff88]" data-id="element-113">
                    {plan.price}
                  </span>
                  <span className="text-gray-400 ml-2" data-id="element-114">{plan.period}</span>
                </div>
              </div>

              <ul className="space-y-3 mb-8" data-id="element-115">
                {plan.features.map((feature, featureIndex) => <li key={featureIndex} className="flex items-start space-x-3" data-id="element-116">
                    <Check className="text-[#00ff88] flex-shrink-0 mt-0.5" size={20} data-id="element-117" />
                    <span className="text-gray-300 text-sm" data-id="element-118">{feature}</span>
                  </li>)}
              </ul>

              <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} onClick={scrollToContact} className={`w-full py-3 rounded-lg font-bold transition-colors ${plan.highlighted ? 'bg-[#d4a017] text-[#0a1a0f] hover:bg-[#e5b526]' : 'bg-[#00ff88] text-[#0a1a0f] hover:bg-[#22c55e]'}`} data-id="element-119">
                Get Started
              </motion.button>
            </motion.div>)}
        </div>
      </div>
    </section>;
}